export const LIST_DEPARTMENT_REQUEST = 'LIST_DEPARTMENT_REQUEST'
export const LIST_DEPARTMENT_SUCCESS = 'LIST_DEPARTMENT_SUCCESS'
export const LIST_DEPARTMENT_FAIL = 'LIST_DEPARTMENT_FAIL'

export const LIST_DEPARTMENT_SUMMARY_REQUEST = 'LIST_DEPARTMENT_SUMMARY_REQUEST'
export const LIST_DEPARTMENT_SUMMARY_SUCCESS = 'LIST_DEPARTMENT_SUMMARY_SUCCESS'
export const LIST_DEPARTMENT_SUMMARY_FAIL = 'LIST_DEPARTMENT_SUMMARY_FAIL'

export const CREATE_DEPARTMENT_REQUEST = 'CREATE_DEPARTMENT_REQUEST'
export const CREATE_DEPARTMENT_SUCCESS = 'CREATE_DEPARTMENT_SUCCESS'
export const CREATE_DEPARTMENT_FAIL = 'CREATE_DEPARTMENT_FAIL'

export const DETAIL_DEPARTMENT_REQUEST = 'DETAIL_DEPARTMENT_REQUEST'
export const DETAIL_DEPARTMENT_SUCCESS = 'DETAIL_DEPARTMENT_SUCCESS'
export const DETAIL_DEPARTMENT_FAIL = 'DETAIL_DEPARTMENT_FAIL'

export const UPDATE_DEPARTMENT_REQUEST = 'UPDATE_DEPARTMENT_REQUEST'
export const UPDATE_DEPARTMENT_SUCCESS = 'UPDATE_DEPARTMENT_SUCCESS'
export const UPDATE_DEPARTMENT_FAIL = 'UPDATE_DEPARTMENT_FAIL'

export const DELETE_DEPARTMENT_REQUEST = 'DELETE_DEPARTMENT_REQUEST'
export const DELETE_DEPARTMENT_SUCCESS = 'DELETE_DEPARTMENT_SUCCESS'
export const DELETE_DEPARTMENT_FAIL = 'DELETE_DEPARTMENT_FAIL'

export const RESET_DEPARTMENT = 'RESET_DEPARTMENT'